<template>
  <el-drawer
    v-if="visible"
    :visible="visible"
    :title="title || $l('dialog_title_putShelves_sku') || '新增海外仓产品'"
    show-close
    size="1000px"
    :close-on-click-modal="false"
    :before-close="() => $refs.main.cancel()"
    :modal-append-to-body="false"
  >
    <div class="ml-4 mr-4">
      <Main ref="main" @reload="$emit('reload')" @close="close()" />
      <div class="mt-2 mb-4 d-flex justify-content-end">
        <el-button size="small" @click="$refs.main.cancel()">
          {{ this.$l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button type="primary" size="small" @click="$refs.main.putShelves()">
          {{ $l('btn_putShelves') || '上架' }}
        </el-button>
      </div>
    </div>
  </el-drawer>
</template>
<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
